import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthorsAdminPanel from "./AuthorsAdminPanel";

const AuthorsAdminPage = () => {
    const { classId, subjectSlug } = useParams();
    const nav = useNavigate();

    return (
        <div>
            <div style={{ marginBottom: 12 }}>
                <button onClick={() => nav(`/manage-portal-9f3a/classes/${classId}/subjects`)}>
                    ← Назад до предметів
                </button>
            </div>

            <AuthorsAdminPanel classId={String(classId)} subjectSlug={String(subjectSlug)} />
        </div>
    );
};

export default AuthorsAdminPage;
